import React from "react";
import { Box, Typography, Chip } from "@mui/material";

export const ProductCategoriesView = ({ items }) => {
  // Group items by MainCategory
  const groupedItems = items.reduce((acc, item) => {
    const mainCategory = item.MainCategory || "Unknown";
    if (!acc[mainCategory]) {
      acc[mainCategory] = [];
    }
    acc[mainCategory].push(item);
    return acc;
  }, {});

  // Create display label for each item
  const getCategoryLabel = (item) => {
    if (item.SubCategory) {
      return item.SubCategory;
    } else if (item.Category) {
      return item.Category;
    }
    return item.MainCategory; // Fixed here
  };

  return (
    <Box>
      {Object.entries(groupedItems).map(([mainCategory, itemsInGroup]) => (
        <Box
          key={mainCategory}
          mb={2}
          p={2}
          border="1px solid #e0e0e0"
          borderRadius="8px"
          bgcolor="#fafafa"
        >
          <Typography variant="body1" color="text.primary" gutterBottom>
            {mainCategory}
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1}>
            {itemsInGroup.map((item, index) => (
              <Chip
                key={index}
                label={getCategoryLabel(item)}
                variant="outlined"
                size="small"
                sx={{ margin: "4px 4px 0 0" }}
              />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};
